'use struct';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Snackbar = require('common/util/snackbar');
const Dialog = require('common/util/dialog');
const SidebarNavListView = require('common/ui/view/sidebar/nav');
const ContentEditView = require('data/ui/view/modal/content-edit');
const ContentService = require('data/app/service/content/index');
const Router = require('balus/app/router/index');
const Template = require('balus/ui/template/body/data-content/toolbar/index.hbs');
const ModalView = require('common/ui/view/modal/index');
const DataPermission = require('data/domain/entity/permission');
const OpenURI = require('data/ui/view/content/open-uri');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        nav: '.sidebar-nav',
        uri: '.uri'
    },
    ui: {
        contentUpdateButton: '.content-update-button',
        contentDeleteButton: '.content-delete-button',
    },
    events: {
        'click @ui.contentUpdateButton': 'updateContent',
        'click @ui.contentDeleteButton': 'deleteContent',
    },

    templateContext: function() {
        const context = this.getOption('context');
        return {
            isUpdatable: context.getProjectRole().getPermission(
                DataPermission.DataContentAddVersionPermission
            ).isPermitted(context),
            isDeletable: context.getProjectRole().getPermission(
                DataPermission.DataContentDeletePermission
            ).isPermitted(context),
        };
    },

    updateContent: function() {
        const content = this.model;
        const project = this.model.getProject();
        const modal = new ModalView({
            title: i18n.t('data:edit.title'),
            bodyView: new ContentEditView({
                model: content,
                project: project
            }),
            onChildviewSave: function() {
                const contentJSON = this.getChildView('body').getContent();
                this.disableButtons();
                (new ContentService.ContentUpdateService(
                    project, content, contentJSON
                ))
                    .update()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    deleteContent: function () {
        const content = this.model;
        const project = content.getProject();
        Dialog.confirm({
            text: i18n.t('balus_view_body_data-content:toolbar.dialog.deleteConfirm', {name: content.getName()}),
            okCallback: () => {
                (new ContentService.ContentDeleteService(
                    project, content
                ))
                    .delete()
                    .then(c => {
                        Snackbar.success(
                            i18n.t('balus_view_body_data-content:toolbar.feedback.delete', {name: c.getName()})
                        );
                        Router.navigateDataContentDashboard(project);
                    });
            }
        })
    },

    onRender: function() {
        this.showChildView('uri', new OpenURI({
            version: this.model.getLatestVersion(),
            project: this.model.getProject(),
        }));
    },

    renderNav: function(navs) {
        this.showChildView('nav', new SidebarNavListView({
            collection: navs,
            horizontal: true
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/data-content/toolbar/index.js